import { captureException } from "@sentry/vue";

export const POST_SAVE_PANEL_HIDDEN_KEY = "integrate_post_save_hidden";

const reportStorageError = (error: unknown) => {
  captureException(error, { tags: { area: "integrate-post-save-pref" } });
};

export function isPostSavePanelHidden(): boolean {
  try {
    return window.localStorage.getItem(POST_SAVE_PANEL_HIDDEN_KEY) === "true";
  } catch (error: unknown) {
    reportStorageError(error);
    return false;
  }
}

export function setPostSavePanelHidden(hidden: boolean): void {
  try {
    if (hidden) {
      window.localStorage.setItem(POST_SAVE_PANEL_HIDDEN_KEY, "true");
      return;
    }
    window.localStorage.removeItem(POST_SAVE_PANEL_HIDDEN_KEY);
  } catch (error: unknown) {
    reportStorageError(error);
  }
}
